import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation";

const splashScreen = {
  enabled: true,
  animation: splashAnimation,
  duration: 2000
};

const illustration = {
  animated: true
};

const greeting = {
  username: "Ananda Lukman",
  title: "Hi all, I'm Lukman",
  subTitle: emoji(
    "A passionate Full Stack Developer 🚀 specializing in creating high-performance Web, Mobile, and Desktop applications. Expert in building dynamic frontends with Next.js and cross-platform mobile solutions with Flutter, managed efficiently using Melos. Proficient in developing robust backend services with Node.js and integrating real-time features using technologies like Pusher and MongoDB."
  ),
  resumeLink: "https://drive.google.com/file/d/1jnGOHBd5UK7KzlEsPRqno2MDrRZTQ2WT/view?usp=sharing",
  displayGreeting: true
};

const socialMediaLinks = {
  github: "https://github.com/anandalukman33",
  linkedin: "https://www.linkedin.com/in/ananda-muhamad-lukman/",
  gmail: "ananda.muhamad.lukman@gmail.com",
  gitlab: "https://gitlab.com/ananda.muhamad.lukman",
  facebook: "https://www.facebook.com/anandalukmann",
  medium: "https://medium.com/@ananda_muhamad_lukman",
  stackoverflow: "https://stackoverflow.com/users/16860134/paijo-anita-sari",
  display: true
};

const skillsSection = {
  title: "What I Do",
  subTitle: "FULL STACK DEVELOPER | WEB, MOBILE & DESKTOP SPECIALIST",
  skills: [
    emoji(
      "⚡ Building responsive, pixel-perfect Front-End applications for Web and Mobile using React.js and Flutter"
    ),
    emoji(
      "⚡ Developing robust Backend Microservices with Node.js & Laravel, featuring real-time event-driven architectures (Pusher)"
    ),
    emoji(
      "⚡ Creating Native-performance Desktop Applications for Windows using C# and WinUI 3 integrated with biometric hardware"
    ),
    emoji(
      "⚡ Architecting scalable Database Schemas (SQL & NoSQL) and managing cloud infrastructure deployment"
    )
  ],

  softwareSkills: [
    {
      skillName: "HTML5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "CSS3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "Sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "ReactJS",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "NextJS",
      fontAwesomeClassname: "fas fa-layer-group"
    },
    {
      skillName: "NodeJS",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "Flutter",
      fontAwesomeClassname: "fas fa-mobile-alt"
      /* Note: Icon 'fab fa-flutter' sering tidak muncul di FontAwesome 5 gratis, 
         jadi saya gunakan 'mobile-alt' sebagai alternatif aman. 
         Jika pro version aktif, bisa dikembalikan ke 'fab fa-flutter' */
    },
    {
      skillName: "Android",
      fontAwesomeClassname: "fab fa-android"
    },
    {
      skillName: "Laravel",
      fontAwesomeClassname: "fab fa-laravel"
    },
    {
      skillName: "MongoDB",
      fontAwesomeClassname: "fas fa-leaf"
    },
    {
      skillName: "SQL DB",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "Firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "Pusher",
      fontAwesomeClassname: "fas fa-broadcast-tower"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "C# WinUI",
      fontAwesomeClassname: "fab fa-microsoft"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-git-alt"
    },
    {
      skillName: "NPM",
      fontAwesomeClassname: "fab fa-npm"
    }
  ],
  display: true
};

const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "Universitas Budi Luhur",
      logo: require("./assets/images/bl.png"),
      subHeader: "Bachelor of Information Technology",
      duration: "July 2016 - April 2021",
      desc: "Focused my thesis on Artificial Intelligence.",
      descBullets: [
        "Developed a Skin Disease Expert System using Backward Chaining and Certainty Factor methods."
      ],
      // --- TAMBAHAN BARU ---
      thesisLink:
        "https://lib.budiluhur.ac.id/Koleksitesis/detail/MXwxNjExNTAxMjA0"
      // ---------------------
    }
  ]
};

const techStack = {
  viewSkillBars: true,
  experience: [
    {
      Stack: "Frontend Development",
      progressPercentage: "90%"
    },
    {
      Stack: "Backend Development",
      progressPercentage: "80%"
    },
    {
      Stack: "Mobile & Desktop Development",
      progressPercentage: "85%"
    }
  ],
  displayCodersrank: false
};

const workExperiences = {
  display: true,
  experience: [
    {
      role: "Mobile, EDC & Desktop Developer",
      company: "BNI Agen 46",
      companylogo: require("./assets/images/bni.png"),
      date: "Sept 2023 – Present",
      desc: "At BNI Agen 46, I develop and maintain multiple critical applications. My responsibilities include the Agen 46 mobile app, a payment platform integrating with EDC, MicroATM, and NFC devices using both native Kotlin and Flutter. I also build secure Windows desktop applications with C# WinUI 3 for biometric authentication using HID U are U fingerprint scanners.",
      descBullets: [
        "EDC & MicroATM Device Integration",
        "Hybrid Mobile App Development with Flutter",
        "C# WinUI 3 Desktop Application Development",
        "Secure Biometric System Integration (HID U are U)"
      ]
    },
    {
      role: "Frontend Web Developer",
      company: "ZappleRepair",
      companylogo: require("./assets/images/zapplerepairindonesia_logo.jpg"),
      date: "Aug 2024 – January 2025",
      desc: "As a Frontend Web Developer, I was responsible for building a responsive and high-performance user interface for Zapplerepair's main application using Next.js. I worked closely with the backend team to ensure seamless API integration and deliver an exceptional user experience.",
      descBullets: [
        "Developed responsive and interactive user interfaces using Next.js and React.",
        "Collaborated with backend teams to integrate RESTful APIs built with Laravel and Node.js.",
        "Implemented state management solutions for a seamless user experience.",
        "Ensured cross-browser compatibility and optimized application performance."
      ]
    },
    {
      role: "Mobile Developer",
      company: "AnterAja",
      companylogo: require("./assets/images/anteraja.jpg"),
      date: "July 2021 – Aug 2023",
      desc: "As a Mobile Developer at AnterAja, I was responsible for developing and maintaining several key Android applications (Staging, Warehouse, and Rider App) that are crucial for the goods delivery ecosystem. I also contributed to quality assurance by implementing automation testing using Katalon.",
      descBullets: [
        "Native Android Development (Kotlin)",
        "Worked within Agile and Scrum Frameworks",
        "Automation Testing with Katalon"
      ]
    },
    {
      role: "Computer Teacher",
      company: "Miftahul Huda",
      companylogo: require("./assets/images/miftada.png"),
      date: "July 2019 – July 2021",
      desc: "I taught foundational computer science and programming concepts to students, covering topics from basic office tools to fundamental web and mobile development principles."
    }
  ]
};

const openSource = {
  showGithubProfile: "true",
  display: true
};

const bigProjects = {
  title: "Big Projects",
  subtitle: "BEBERAPA PROYEK TERBAIK YANG PERNAH SAYA KERJAKAN",
  display: true,
  sections: [
    {
      title: "📱 Frontend Mobile Applications",
      projects: [
        {
          image: require("./assets/images/kicau_pro.png"),
          projectName: "Kicau Pro",
          projectDesc: "Asisten cerdas perawatan burung dengan AI.",
          footerLink: [
            {
              name: "Play Store",
              url: "https://play.google.com/store/apps/details?id=id.park_yasha.app_kicaupro"
            }
          ],
          caseStudy: {
            challenge:
              "User kesulitan mengatur jadwal perawatan burung yang kompleks.",
            solution:
              "Membuat sistem reminder otomatis berbasis jadwal user dan fitur audio mastering.",
            architecture: ["Flutter", "Pusher", "Node.js", "Postgres", "Blob Storage"],
            impact: "10k+ Downloads, 4.5 Rating."
          },
          gallery: [
            // Gallery Screenshot App
            require("./assets/images/kicau_pro_ss/kicau_pro_1.jpeg"),
            require("./assets/images/kicau_pro_ss/kicau_pro_2.jpeg"),
            require("./assets/images/kicau_pro_ss/kicau_pro_3.jpeg"),
            require("./assets/images/kicau_pro_ss/kicau_pro_4.jpeg"),
            require("./assets/images/kicau_pro_ss/kicau_pro_5.jpeg"),
            require("./assets/images/kicau_pro_ss/kicau_pro_6.jpeg"),
            require("./assets/images/kicau_pro_ss/kicau_pro_7.jpeg"),
            require("./assets/images/kicau_pro_ss/kicau_pro_8.jpeg"),
            require("./assets/images/kicau_pro_ss/kicau_pro_9.jpeg"),
            require("./assets/images/kicau_pro_ss/kicau_pro_10.jpeg"),
            require("./assets/images/kicau_pro_ss/kicau_pro_11.jpeg"),
            require("./assets/images/kicau_pro_ss/kicau_pro_12.jpeg"),
            require("./assets/images/kicau_pro_ss/kicau_pro_13.jpeg"),
            require("./assets/images/kicau_pro_ss/kicau_pro_14.jpeg"),
            require("./assets/images/kicau_pro_ss/kicau_pro_15.jpeg"),
            require("./assets/images/kicau_pro_ss/kicau_pro_16.jpeg"),
            require("./assets/images/kicau_pro_ss/kicau_pro_17.jpeg"),
            require("./assets/images/kicau_pro_ss/kicau_pro_18.jpeg"),
            require("./assets/images/kicau_pro_ss/kicau_pro_19.jpeg"),
            require("./assets/images/kicau_pro_ss/kicau_pro_20.jpeg"),
            require("./assets/images/kicau_pro_ss/kicau_pro_21.jpeg"),
            require("./assets/images/kicau_pro_ss/kicau_pro_22.jpeg"),
            require("./assets/images/kicau_pro_ss/kicau_pro_23.jpeg"),
            require("./assets/images/kicau_pro_ss/kicau_pro_24.jpeg")
          ]
        },
        {
          image: require("./assets/images/bni.png"), // Pastikan gambar ada atau ganti placeholder
          projectName: "Agen 46 Mobile (Hybrid)",
          projectDesc: "Aplikasi perbankan agen BNI untuk transaksi finansial.",
          footerLink: [
            {
              name: "Info BNI",
              url: "https://www.bni.co.id/id-id/beranda/agen46"
            }
          ],
          caseStudy: {
            challenge:
              "Migrasi sistem native lama ke framework modern yang support multi-platform dan koneksi hardware EDC.",
            solution:
              "Mengembangkan ulang menggunakan Flutter dengan bridging native untuk koneksi MicroATM & EDC, dan Revamp menjadi Arsitektur yangg lebih modern menjadi modularisasi",
            architecture: ["Flutter", "Kotlin (Native Bridge)"],
            impact:
              "Peningkatan performa aplikasi dan kemudahan maintenance satu codebase."
          }
        },
        {
          image: require("./assets/images/obasaka.png"),
          projectName: "Obasaka Stream",
          projectDesc: "Platform streaming anime ().",
          footerLink: [],
          caseStudy: {
            challenge: "Minimnya aplikasi streaming lokal yang hemat kuota.",
            solution: "Algoritma kompresi video custom dan caching offline.",
            architecture: ["Android", "Kotlin", "NodeJS", "MongoDB"],
            impact: "5.000+ User aktif harian."
          },
          gallery: [
            // Gallery Screenshot App
            require("./assets/images/obasaka_ss/obasaka_1.png"),
            require("./assets/images/obasaka_ss/obasaka_2.png"),
            require("./assets/images/obasaka_ss/obasaka_3.png"),
            require("./assets/images/obasaka_ss/obasaka_4.png")
          ]
        },
        {
          image: require("./assets/images/anteraja.jpg"), // Pastikan gambar ada atau ganti placeholder
          projectName: "PIC of WarehouseApp, StagingApp, and RiderApp",
          projectDesc: "Pengembangan Aplikasi Internal Anteraja",
          footerLink: [
            {
              name: "Info Anteraja",
              url: "https://anteraja.id/"
            }
          ],
          caseStudy: {
            challenge:
              "Handling 3 Aplikasi Sekaligus.",
            solution:
              "Metodologi Kerja Scrum and Agile",
            architecture: ["Kotlin", "Java", "Android"],
            impact:
              "Mempercepat Development"
          }
        }
      ]
    },
    {
      title: "💻 Frontend Web Applications",
      projects: [
        {
          image: require("./assets/images/zapplerepairindonesia_logo.jpg"),
          projectName: "Zapple Repair Web",
          projectDesc: "Portal layanan perbaikan gadget Apple profesional.",
          footerLink: [{name: "Visit Web", url: "https://zapplerepair.com/"}],
          caseStudy: {
            challenge: "Website lama lambat dan tidak SEO-friendly.",
            solution:
              "Membangun ulang dengan Next.js (SSR) untuk performa loading <2 detik dan SEO optimal.",
            architecture: ["Next.js", "React", "Sass"],
            impact: "Traffic organik meningkat 40% dalam 3 bulan."
          }
        },
      ]
    },
    {
      title: "⚙️ Desktop Application",
      projects: [
        {
          image: require("./assets/images/bni.png"),
          projectName: "HID Camera U Are U",
          projectDesc:
            "RND Camera Anti Spoofing dan Liveness untuk installasi di cabang BNI.",
          footerLink: [],
          caseStudy: {
            challenge:
              "Integrasi hardware Camera (HID U are U) yang aman pada Windows.",
            solution:
              "Aplikasi Desktop .Net C# dengan LifeCycle level tinggi.",
            architecture: ["C# .Net", ".NET 6", "HID SDK"],
            impact:
              "Digunakan oleh staf internal untuk akses sistem core banking."
          }
        }
      ]
    }
  ]
};

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",
  achievementsCards: [],
  display: false
};

const blogSection = {
  title: "Blogs",
  subtitle: "I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true",
  blogs: [],
  display: false
};

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),
  talks: [],
  display: true
};

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",
  podcast: [],
  display: true
};

const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",
  display: true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+62-895363780972",
  email_address: "ananda.muhamad.lukman@gmail.com"
};

const twitterDetails = {
  userName: "twitter",
  display: false
};

const isHireable = true;

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
